var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.map)?_c('v-dialog',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickedOutside),expression:"clickedOutside"}],model:{value:(_vm.map),callback:function ($$v) {_vm.map=$$v},expression:"map"}},[(_vm.map)?_c('open-map',{attrs:{"map":_vm.map},on:{"close":function($event){return _vm.$emit('close')}}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }